module.exports = "<a href=\"link || 'javascript:;'\" v-link=\"routerLink\" class=\"weui_tabbar_item\" :class=\"{'weui_bar_item_on': isOn}\">\n  <div class=\"weui_tabbar_icon\">\n    <slot name=\"icon\"></slot>\n  </div>\n  <div class=\"weui_tabbar_label\">\n    <slot name=\"label\"></slot>\n  </div>\n</a>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tab/tabbar-item.vue
 ** module id = 145
 ** module chunks = 0
 **/